import React from 'react'
import {useTranslation} from 'react-i18next'
import checkmark from 'assets/checkmark.svg'
import cross from 'assets/cross-in-circle.svg'

type ProgressPoint = {
    title: string
    status: 'success' | 'current' | 'error' | 'empty'
}

export const StepProgressBar = ({points}: {points: ProgressPoint[]}) => {
    return (
        <div className="relative flex flex-1 justify-between">
            {points.map((p, idx) => (
                <Point key={p.title} p={p} idx={idx} />
            ))}
            <div className="absolute left-5 right-5 top-3 h-0.5 bg-yellow-30" />
        </div>
    )
}

const Point = ({p, idx}: {p: ProgressPoint; idx: number}) => {
    const {t} = useTranslation()

    return (
        <div key={p.title} className="z-10 flex flex-col items-center">
            <div
                className={` flex h-7 
                w-7 items-center justify-center 
                rounded-full border-2 border-yellow-30 
                ${p.status === 'success' ? 'bg-yellow-30' : 'bg-white'}
            `}
            >
                {p.status === 'success' ? (
                    <img className="w-4 pt-1" src={checkmark} alt="success" />
                ) : null}
                {p.status === 'error' ? <img src={cross} alt="error" /> : null}
                {p.status === 'current' ? (
                    <div className="h-3 w-3 rounded-full bg-yellow-30" />
                ) : null}
            </div>
            <div className="text-sm font-bold text-yellow-30">
                {t('ONBOARDING_STEP')} {idx + 1}
            </div>
            <div className="text-[0.625rem] text-yellow-30">{p.title}</div>
        </div>
    )
}
export default StepProgressBar
